import { lsApiService, lsErrorService } from 'ls-vue-common';

import { SCHEDULE_CYCLES__GET_DETAILS, SCHEDULE_CYCLES__MUTATE_DETAILS } from '@/store/types';

const createInitialState = () => {
  return {
    details: {},
  };
};

export const mutations = {
  [SCHEDULE_CYCLES__MUTATE_DETAILS](state, payload) {
    const { scheduleId, details } = payload;

    state.details[scheduleId] = details;
  },
};

export const actions = {
  async [SCHEDULE_CYCLES__GET_DETAILS]({ commit }, { customerId, propertyId, scheduleId }) {
    return lsApiService
      .request({
        apiVersion: 'v2',
        method: 'GET',
        route: `/customers/${customerId}/properties/${propertyId}/schedules/${scheduleId}/cycle/details`,
      })
      .then(({ data }) => {
        commit(SCHEDULE_CYCLES__MUTATE_DETAILS, {
          scheduleId: scheduleId,
          details: data,
        });
      })
      .catch((error) => {
        lsErrorService.log({ error, showAlert: true });
      });
  },
};

export const scheduleCycles = {
  state: createInitialState,
  mutations,
  actions,
};
